var LG_LS_H2766PG = {
  name: "LG LS-H2766PG",
  defaultCommandIndex: 1,
  commands: [
    {
      mode: "AC_MODE_OFF",
      temperature: "AC_TEMP_NULL",
      fan: "AC_FAN_NULL",
      command: [59,0,4,82,2,175,1,65,33,27,16,92,2,208,5,88,2,0,0,79,60,159,254,103,145,0],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_LOW",
      command: [59,0,4,88,2,168,1,67,33,39,16,88,2,210,5,81,2,0,0,79,63,255,159,228,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_LOW",
      command: [59,0,4,87,2,168,1,65,33,34,16,93,2,205,5,97,2,0,0,79,63,255,63,204,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_LOW",
      command: [59,0,4,88,2,153,1,94,33,30,16,94,2,212,5,79,2,0,0,79,63,255,39,242,68],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_LOW",
      command: [59,0,4,77,2,168,1,64,33,40,16,86,2,221,5,98,2,0,0,79,63,254,127,156,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_LOW",
      command: [59,0,4,82,2,153,1,64,33,43,16,84,2,215,5,102,2,0,0,79,63,254,103,230,68],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_LOW",
      command: [59,0,4,90,2,146,1,61,33,35,16,87,2,208,5,94,2,0,0,79,63,254,79,228,196],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_LOW",
      command: [59,0,4,76,2,168,1,62,33,27,16,93,2,219,5,79,2,0,0,79,63,254,73,249,36,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_LOW",
      command: [59,0,4,89,2,168,1,82,33,34,16,93,2,209,5,98,2,0,0,79,63,252,255,60,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_LOW",
      command: [59,0,4,85,2,138,1,62,33,28,16,93,2,208,5,82,2,0,0,79,63,252,231,206,68],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_LOW",
      command: [59,0,4,88,2,143,1,86,33,27,16,96,2,206,5,135,2,0,0,79,63,252,207,204,196],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_LOW",
      command: [59,0,4,91,2,162,1,61,33,31,16,93,2,199,5,81,2,0,0,79,63,252,201,243,36,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_LOW",
      command: [59,0,4,76,2,168,1,57,33,29,16,91,2,220,5,106,2,0,0,79,63,252,159,201,196],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_LOW",
      command: [59,0,4,87,2,166,1,86,33,29,16,93,2,210,5,81,2,0,0,79,63,252,153,242,100,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_LOW",
      command: [59,0,4,78,2,148,1,60,33,34,16,87,2,218,5,94,2,0,0,79,63,252,147,242,76,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_LOW",
      command: [59,0,4,91,2,170,1,66,33,9,16,109,2,205,5,80,2,0,0,79,63,252,146,124,146,68],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_MID",
      command: [59,0,4,93,2,167,1,64,33,33,16,96,2,196,5,120,2,0,0,79,63,255,156,242,68],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_MID",
      command: [59,0,4,88,2,167,1,62,33,32,16,94,2,200,5,102,2,0,0,79,63,255,60,231,16],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_MID",
      command: [59,0,4,86,2,171,1,54,33,38,16,85,2,210,5,94,2,0,0,79,63,255,39,57,145,0],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_MID",
      command: [59,0,4,83,2,168,1,66,33,27,16,96,2,215,5,97,2,0,0,79,63,254,124,228,196],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_MID",
      command: [59,0,4,97,2,162,1,68,33,34,16,94,2,190,5,100,2,0,0,79,63,254,103,57,36,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_MID",
      command: [59,0,4,80,2,167,1,83,33,33,16,93,2,216,5,99,2,0,0,79,63,254,79,51,196],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_MID",
      command: [59,0,4,96,2,162,1,83,33,36,16,90,2,191,5,92,2,0,0,79,63,254,73,204,228,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_MID",
      command: [59,0,4,93,2,161,1,59,33,11,16,112,2,200,5,96,2,0,0,79,63,252,252,204,196],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_MID",
      command: [59,0,4,76,2,172,1,65,33,32,16,91,2,218,5,80,2,0,0,79,63,252,231,51,36,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_MID",
      command: [59,0,4,94,2,166,1,61,33,10,16,109,2,196,5,104,2,0,0,79,63,252,207,50,113,0],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_MID",
      command: [59,0,4,82,2,170,1,68,33,36,16,88,2,215,5,80,2,0,0,79,63,252,201,204,153,16],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_MID",
      command: [59,0,4,88,2,174,1,95,33,36,16,89,2,202,5,94,2,0,0,79,63,252,159,50,76,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_MID",
      command: [59,0,4,87,2,168,1,64,33,36,16,85,2,209,5,78,2,0,0,79,63,252,153,204,146,68],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_MID",
      command: [59,0,4,79,2,167,1,62,33,9,16,112,2,217,5,100,2,0,0,79,63,252,147,207,196],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_MID",
      command: [59,0,4,92,2,173,1,86,33,37,16,89,2,199,5,93,2,0,0,79,63,252,146,115,228,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_HIGH",
      command: [59,0,4,78,2,142,1,68,33,35,16,91,2,218,5,80,2,0,0,79,63,255,153,230,68],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_HIGH",
      command: [59,0,4,91,2,167,1,95,2,204,5,91,33,25,16,94,2,0,0,47,127,254,239,88,128],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_HIGH",
      command: [59,0,4,87,2,149,1,59,33,34,16,87,2,206,5,80,2,0,0,79,63,255,38,121,36,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_HIGH",
      command: [59,0,4,91,2,167,1,55,33,33,16,90,2,203,5,100,2,0,0,79,63,254,121,207,16],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_HIGH",
      command: [59,0,4,83,2,141,1,79,33,38,16,83,2,211,5,81,2,0,0,79,63,254,102,115,145,0],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_HIGH",
      command: [59,0,4,87,2,166,1,62,33,26,16,94,2,205,5,126,2,0,0,79,63,254,78,115,49,0],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_HIGH",
      command: [59,0,4,78,2,167,1,58,33,39,16,81,2,219,5,79,2,0,0,79,63,254,73,156,201,16],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_HIGH",
      command: [59,0,4,87,2,167,1,65,33,12,16,108,2,207,5,93,2,0,0,79,63,252,249,201,196],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_HIGH",
      command: [59,0,4,75,2,171,1,57,33,32,16,89,2,218,5,81,2,0,0,79,63,252,230,114,100,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_HIGH",
      command: [59,0,4,87,2,142,1,60,33,30,16,91,2,204,5,133,2,0,0,79,63,252,206,114,76,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_HIGH",
      command: [59,0,4,87,2,170,1,53,33,37,16,84,2,209,5,80,2,0,0,79,63,252,201,156,146,68],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_HIGH",
      command: [59,0,4,78,2,150,1,92,33,26,16,95,2,218,5,105,2,0,0,79,63,252,158,127,16],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_HIGH",
      command: [59,0,4,90,2,166,1,56,33,35,16,87,2,200,5,80,2,0,0,79,63,252,153,159,145,0],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_HIGH",
      command: [59,0,4,85,2,171,1,80,2,211,5,56,33,40,16,97,2,0,0,47,127,250,187,236,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_HIGH",
      command: [59,0,4,83,2,166,1,59,33,32,16,87,2,214,5,81,2,0,0,79,63,252,146,103,201,16],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_AUTO",
      command: [59,0,4,83,2,153,1,62,33,35,16,89,2,212,5,93,2,0,0,79,63,255,153,153,49,0],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_AUTO",
      command: [59,0,4,78,2,150,1,67,33,38,16,86,2,219,5,81,2,0,0,79,63,255,57,153,36,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_AUTO",
      command: [59,0,4,86,2,164,1,94,2,209,5,60,33,25,16,96,2,0,0,47,127,254,182,188,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_AUTO",
      command: [59,0,4,90,2,137,1,97,2,203,5,87,33,26,16,81,2,0,0,47,127,253,237,116,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_AUTO",
      command: [59,0,4,79,2,167,1,65,33,40,16,85,2,216,5,99,2,0,0,79,63,254,102,100,204,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_AUTO",
      command: [59,0,4,80,2,151,1,65,33,34,16,86,2,217,5,79,2,0,0,79,63,254,78,100,201,16],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_AUTO",
      command: [59,0,4,95,2,141,1,64,33,35,16,88,2,193,5,100,2,0,0,79,63,254,73,153,39,16],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_AUTO",
      command: [59,0,4,83,2,169,1,60,33,29,16,92,2,215,5,81,2,0,0,79,63,252,249,146,100,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_AUTO",
      command: [59,0,4,87,2,168,1,54,33,28,16,93,2,205,5,94,2,0,0,79,63,252,230,100,147,16],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_AUTO",
      command: [59,0,4,88,2,139,1,60,33,31,16,88,2,205,5,93,2,0,0,79,63,252,206,100,146,68],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_AUTO",
      command: [59,0,4,88,2,170,1,50,33,28,16,93,2,203,5,101,2,0,0,79,63,252,201,153,241,0],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_AUTO",
      command: [59,0,4,88,2,164,1,62,33,27,16,95,2,206,5,78,2,0,0,79,63,252,158,103,145,0],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_AUTO",
      command: [59,0,4,91,2,141,1,64,33,34,16,88,2,200,5,130,2,0,0,79,63,252,153,153,204,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_AUTO",
      command: [59,0,4,88,2,164,1,59,33,38,16,84,2,205,5,92,2,0,0,79,63,252,147,153,201,16],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_AUTO",
      command: [59,0,4,89,2,170,1,55,33,39,16,86,2,203,5,103,2,0,0,79,63,252,146,102,103,16],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_LOW",
      command: [59,0,4,91,2,169,1,73,33,15,16,107,2,196,5,106,2,0,0,79,63,231,231,230,68],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_LOW",
      command: [59,0,4,77,2,168,1,95,2,220,5,56,33,26,16,93,2,0,0,47,127,223,127,88,128],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_LOW",
      command: [59,0,4,86,2,167,1,61,33,35,16,88,2,211,5,79,2,0,0,79,63,231,201,249,36,64],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_LOW",
      command: [59,0,4,77,2,156,1,64,33,41,16,87,2,220,5,105,2,0,0,79,63,231,159,207,16],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_LOW",
      command: [59,0,4,86,2,167,1,57,33,37,16,89,2,210,5,79,2,0,0,79,63,231,153,243,145,0],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_LOW",
      command: [59,0,4,90,2,149,1,67,33,38,16,86,2,205,5,110,2,0,0,79,63,231,147,243,49,0],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_LOW",
      command: [59,0,4,93,2,168,1,64,33,31,16,88,2,199,5,80,2,0,0,79,63,231,146,124,201,16],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_LOW",
      command: [59,0,4,77,2,166,1,55,33,39,16,86,2,216,5,76,2,0,0,79,63,231,63,201,196],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_LOW",
      command: [59,0,4,80,2,149,1,56,33,28,16,93,2,215,5,79,2,0,0,79,63,231,57,242,100,64],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_LOW",
      command: [59,0,4,91,2,142,1,66,33,38,16,87,2,200,5,120,2,0,0,79,63,231,51,242,76,64],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_LOW",
      command: [59,0,4,90,2,163,1,55,33,39,16,83,2,206,5,81,2,0,0,79,63,231,50,124,146,68],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_LOW",
      command: [59,0,4,88,2,170,1,66,33,40,16,87,2,207,5,96,2,0,0,79,63,231,39,255,16],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_LOW",
      command: [59,0,4,90,2,165,1,58,33,27,16,95,2,206,5,81,2,0,0,79,63,231,38,127,145,0],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_LOW",
      command: [59,0,4,87,2,170,1,64,33,27,16,93,2,202,5,101,2,0,0,79,63,231,36,255,49,0],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_LOW",
      command: [59,0,4,86,2,138,1,64,33,35,16,85,2,209,5,81,2,0,0,79,63,231,36,159,201,16],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_MID",
      command: [59,0,4,77,2,171,1,57,33,6,16,115,2,218,5,80,2,0,0,79,63,231,231,57,36,64],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_MID",
      command: [59,0,4,77,2,169,1,66,33,36,16,91,2,217,5,97,2,0,0,79,63,231,207,51,196],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_MID",
      command: [59,0,4,87,2,166,1,58,33,30,16,91,2,204,5,80,2,0,0,79,63,231,201,204,228,64],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_MID",
      command: [59,0,4,86,2,170,1,65,33,27,16,95,2,205,5,98,2,0,0,79,63,231,159,51,49,0],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_MID",
      command: [59,0,4,90,2,149,1,57,33,33,16,89,2,202,5,97,2,0,0,79,63,231,153,204,201,16],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_MID",
      command: [59,0,4,77,2,167,1,58,33,54,16,69,2,217,5,103,2,0,0,79,63,231,147,204,156,64],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_MID",
      command: [59,0,4,89,2,162,1,66,33,36,16,87,2,203,5,95,2,0,0,79,63,231,146,115,38,68],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_MID",
      command: [59,0,4,92,2,172,1,86,33,40,16,84,2,199,5,132,2,0,0,79,63,231,63,50,76,64],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_MID",
      command: [59,0,4,88,2,138,1,58,33,40,16,86,2,205,5,93,2,0,0,79,63,231,57,204,146,68],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_MID",
      command: [59,0,4,88,2,143,1,61,33,7,16,114,2,206,5,94,2,0,0,79,63,231,51,207,196],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_MID",
      command: [59,0,4,92,2,171,1,83,33,9,16,108,2,195,5,97,2,0,0,79,63,231,50,115,228,64],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_MID",
      command: [59,0,4,90,2,164,1,81,33,39,16,87,2,205,5,129,2,0,0,79,63,231,39,207,49,0],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_MID",
      command: [59,0,4,89,2,167,1,64,33,38,16,88,2,200,5,84,2,0,0,79,63,231,38,115,201,16],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_MID",
      command: [59,0,4,89,2,167,1,68,33,0,16,117,2,206,5,120,2,0,0,79,63,231,36,243,156,64],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_MID",
      command: [59,0,4,86,2,166,1,60,33,27,16,93,2,211,5,91,2,0,0,79,63,231,36,156,230,68],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_HIGH",
      command: [59,0,4,87,2,166,1,60,33,29,16,94,2,204,5,78,2,0,0,79,63,231,230,115,145,0],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_HIGH",
      command: [59,0,4,91,2,171,1,57,33,29,16,92,2,199,5,91,2,0,0,79,63,231,206,115,49,0],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_HIGH",
      command: [59,0,4,89,2,166,1,63,33,25,16,96,2,201,5,95,2,0,0,79,63,231,201,156,201,16],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_HIGH",
      command: [59,0,4,84,2,144,1,66,33,31,16,91,2,209,5,96,2,0,0,79,63,231,158,114,113,0],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_HIGH",
      command: [59,0,4,85,2,138,1,64,33,29,16,89,2,204,5,87,2,0,0,79,63,231,153,156,153,16],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_HIGH",
      command: [59,0,4,89,2,164,1,93,33,37,16,88,2,206,5,93,2,0,0,79,63,231,147,156,147,16],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_HIGH",
      command: [59,0,4,85,2,165,1,84,2,210,5,61,33,34,16,79,2,0,0,47,127,222,173,213,68],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_HIGH",
      command: [59,0,4,93,2,169,1,57,33,30,16,93,2,193,5,99,2,0,0,79,63,231,62,127,16],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_HIGH",
      command: [59,0,4,85,2,169,1,65,33,26,16,96,2,207,5,92,2,0,0,79,63,231,57,159,145,0],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_HIGH",
      command: [59,0,4,92,2,167,1,60,33,37,16,86,2,200,5,103,2,0,0,79,63,231,51,159,49,0],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_HIGH",
      command: [59,0,4,86,2,168,1,61,33,32,16,90,2,210,5,80,2,0,0,79,63,231,50,103,201,16],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_HIGH",
      command: [59,0,4,85,2,171,1,61,33,30,16,91,2,209,5,95,2,0,0,79,63,231,39,158,113,0],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_HIGH",
      command: [59,0,4,87,2,164,1,58,33,37,16,87,2,205,5,80,2,0,0,79,63,231,38,103,153,16],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_HIGH",
      command: [59,0,4,90,2,169,1,55,33,27,16,94,2,204,5,99,2,0,0,79,63,231,36,231,147,16],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_HIGH",
      command: [59,0,4,67,33,37,16,88,2,170,1,83,2,208,5,80,2,0,0,149,74,170,169,82,73,74,164,145,0],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_AUTO",
      command: [59,0,4,83,2,166,1,56,33,29,16,94,2,209,5,96,2,0,0,79,63,231,230,100,204,64],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_AUTO",
      command: [59,0,4,79,2,169,1,60,33,40,16,84,2,219,5,80,2,0,0,79,63,231,206,100,201,16],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_AUTO",
      command: [59,0,4,90,2,166,1,69,33,38,16,85,2,197,5,106,2,0,0,79,63,231,201,153,39,16],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_AUTO",
      command: [59,0,4,85,2,163,1,59,33,27,16,94,2,209,5,81,2,0,0,79,63,231,158,100,153,16],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_AUTO",
      command: [59,0,4,82,2,164,1,66,33,39,16,82,2,215,5,97,2,0,0,79,63,231,153,153,36,196],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_AUTO",
      command: [59,0,4,62,33,28,16,83,2,168,1,89,2,212,5,80,2,0,0,149,74,170,169,84,149,41,36,145,0],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_AUTO",
      command: [59,0,4,85,2,169,1,83,33,28,16,93,2,208,5,137,2,0,0,79,63,231,146,102,124,64],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_AUTO",
      command: [59,0,4,88,2,169,1,68,33,39,16,85,2,205,5,81,2,0,0,79,63,231,62,103,145,0],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_AUTO",
      command: [59,0,4,75,2,170,1,83,33,33,16,91,2,219,5,101,2,0,0,79,63,231,57,153,204,64],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_AUTO",
      command: [59,0,4,87,2,171,1,61,33,30,16,92,2,207,5,80,2,0,0,79,63,231,51,153,201,16],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_AUTO",
      command: [59,0,4,83,2,168,1,88,2,203,5,67,33,34,16,105,2,0,0,47,127,221,173,183,16],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_AUTO",
      command: [59,0,4,76,2,160,1,91,2,218,5,57,33,35,16,83,2,0,0,47,127,221,123,109,16],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_AUTO",
      command: [59,0,4,93,2,144,1,69,33,39,16,86,2,198,5,135,2,0,0,79,63,231,38,102,100,196],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_AUTO",
      command: [59,0,4,59,33,30,16,87,2,210,5,86,2,163,1,80,2,0,0,164,148,146,73,37,37,82,82,149,68],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_AUTO",
      command: [59,0,4,84,2,170,1,59,33,27,16,90,2,214,5,96,2,0,0,79,63,231,36,153,147,196],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_NULL",
      fan: "AC_FAN_LOW",
      command: [59,0,4,80,2,164,1,68,33,37,16,88,2,218,5,78,2,0,0,79,63,249,63,206,68],
    },
  ]
};

export default LG_LS_H2766PG
